define("shared/utils/media-adjustments/fetch-by-media-item", ["exports", "later/utils/fetch", "shared/utils/media-adjustments/request-cache", "shared/utils/retry"], function (_exports, _fetch, _requestCache, _retry) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.fetchMediaAdjustmentsByMediaItem = fetchMediaAdjustmentsByMediaItem;
  _exports.requestMediaAdjustmentsPreviewByMediaItem = requestMediaAdjustmentsPreviewByMediaItem;
  0; //eaimeta@70e063a35619d71f0,"later/utils/fetch",0,"shared/utils/media-adjustments/request-cache",0,"shared/utils/retry"eaimeta@70e063a35619d71f
  const inFlightPreviewRequests = new Map();
  function buildQueryString(params) {
    const searchParams = new URLSearchParams();
    (0, _requestCache.normalizedParamEntries)(params).forEach(_ref => {
      let [key, value] = _ref;
      searchParams.set(key, value);
    });
    const query = searchParams.toString();
    return query ? `?${query}` : '';
  }
  async function fetchMediaAdjustmentsByMediaItem(mediaItemId, params, options) {
    const query = buildQueryString(params);
    const cacheKey = (0, _requestCache.buildMediaItemAdjustmentsCacheKey)(mediaItemId, params);
    return (0, _requestCache.fetchWithCache)(cacheKey, () => (0, _fetch.fetch)(`/api/v2/media_items/${mediaItemId}/media_adjustments.json${query}`, {
      method: 'GET'
    }), options);
  }
  function parseMediaAdjustmentsResponse(body) {
    if (!body) {
      return {
        media_adjustments: {}
      };
    }
    try {
      const parsed = JSON.parse(body);
      return parsed?.media_adjustments ? parsed : {
        media_adjustments: {}
      };
    } catch {
      return {
        media_adjustments: {}
      };
    }
  }
  async function requestMediaAdjustmentsPreviewByMediaItem(mediaItemId, params) {
    const cacheKey = (0, _requestCache.buildMediaItemAdjustmentsCacheKey)(mediaItemId, params);
    (0, _requestCache.invalidateMediaAdjustmentsCacheKey)(cacheKey);
    const inFlightRequest = inFlightPreviewRequests.get(cacheKey);
    if (inFlightRequest) {
      return inFlightRequest;
    }
    const request = (async () => {
      // Unsaved PMI spec is resolved from query params (same as GET). Body-only POST does not enqueue preview.
      const query = buildQueryString(params);
      const response = await (0, _fetch.fetch)(`/api/v2/media_items/${mediaItemId}/media_adjustments.json${query}`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      }, {
        intl: null,
        numRetries: 3,
        retryStrategy: _retry.STRATEGY.DEFAULT,
        raw: true
      });
      return parseMediaAdjustmentsResponse(await response.text());
    })();
    inFlightPreviewRequests.set(cacheKey, request);
    try {
      return await request;
    } finally {
      inFlightPreviewRequests.delete(cacheKey);
    }
  }
});